/**
 * Date helpers shared across the app.
 * Kept dependency-free (no date-fns/dayjs) to match the original
 * vanilla-JS mockup logic 1:1.
 */

/** 'YYYY-MM-DD' key used to index events by day (local time, not UTC). */
export function dateKey(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/** Inverse of dateKey(): 'YYYY-MM-DD' -> local Date object at midnight. */
export function parseDateKey(str) {
  const [y, m, d] = str.split('-').map(Number);
  return new Date(y, m - 1, d);
}

/** True if two Date objects fall on the same calendar day. */
export function sameDate(a, b) {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

const WEEKDAY_JP = ['日', '月', '火', '水', '木', '金', '土'];

/** '7月14日（火）の予定' — used as the "選択した日の予定" section label. */
export function formatAgendaLabel(date) {
  const w = WEEKDAY_JP[date.getDay()];
  return `${date.getMonth() + 1}月${date.getDate()}日（${w}）の予定`;
}

/** '2026年7月14日（火）' — used in the EventFormSheet date field. */
export function formatFullDateJP(date) {
  const w = WEEKDAY_JP[date.getDay()];
  return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日（${w}）`;
}

/** '2026年7月' — used as the calendar header month label. */
export function formatMonthLabel(year, month) {
  return `${year}年${month + 1}月`;
}

/**
 * Builds a 35-cell (5-week) grid of Date objects for a given month,
 * starting from the Sunday on/before the 1st, matching the layout used
 * by CalendarMonth and the in-sheet date picker.
 */
export function buildMonthGrid(year, month) {
  const firstDay = new Date(year, month, 1);
  const startOffset = firstDay.getDay();
  const gridStart = new Date(year, month, 1 - startOffset);

  return Array.from({ length: 35 }, (_, i) => {
    const d = new Date(gridStart);
    d.setDate(gridStart.getDate() + i);
    return d;
  });
}

/**
 * Sorts a day's events the way TodaySchedule / SelectedDayEvents
 * require: all-day events first, then timed events by start time.
 */
export function sortDayEvents(events) {
  return [...events].sort((a, b) => {
    if (a.allDay && !b.allDay) return -1;
    if (!a.allDay && b.allDay) return 1;
    if (a.allDay && b.allDay) return 0;
    return (a.start || '').localeCompare(b.start || '');
  });
}
